module.exports = __webpack_public_path__ + "img/get-academy.de7e6a4f.png";